module.exports = __webpack_public_path__ + "img/topup_failed.ae642501.svg";